import { useEffect, useState } from 'react'
import { Button, Input, InputGroup, InputRightElement, Text } from '@chakra-ui/react'
import { EventKey } from 'configs/constants/enums/event'
import { useStores } from 'hooks/useStores'
import { observer } from 'mobx-react'
import qs from 'qs'
import { useNavigate, useLocation } from 'react-router-dom'
import SvgIcon from 'components/SvgIcon'
import { EEsGlobalSearchCollection } from 'constants/elasticSearch'
import { ITheme } from 'interfaces/theme'
import routes from 'routes'

export interface ISearchPageQuery {
  searchText?: string
  page?: number
}

const TopbarSearch = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { pathname } = location

  const { organizationStore, searchStore } = useStores()
  const { organization } = organizationStore
  const currentTheme: ITheme = organization?.theme ?? {}

  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const query: ISearchPageQuery = qs.parse(location.search, { ignoreQueryPrefix: true })
  const [keyword, setKeyword] = useState<string>(query?.searchText ?? '')

  function toggleDropdown(value?: boolean): void {
    setIsDropdownOpen(value ?? !isDropdownOpen)
  }

  function gotoSearchPage(): void {
    searchStore.clearSearchResults()
    searchStore.setManageMode(false)
    searchStore.clearSearchFilter()
    searchStore.setDisplayTypes([EEsGlobalSearchCollection.PROCESS])
    searchStore.setSearchText(keyword)
    searchStore.changeSearchFilter({
      collections: [],
      documentTypes: [],
      groups: [],
      sort: ''
    })
    searchStore.search()
    const searchResultRoute = `${routes.search.value}?searchText=${keyword}&page=1`
    navigate(searchResultRoute)
  }

  function handleSearch(event: { key: string }): void {
    if (event?.key === EventKey.ENTER) {
      gotoSearchPage()
    }
  }

  useEffect(() => {
    setKeyword(query?.searchText ?? '')
  }, [location])

  useEffect(() => {
    if (isDropdownOpen) {
      toggleDropdown(false)
    }
  }, [pathname])

  return (
    <InputGroup borderRadius="6px" maxWidth={{ base: 'max(100%, 300px)', lg: '480px' }} background="white">
      <Input
        paddingRight={104}
        type="search"
        placeholder="Enter keywords..."
        value={keyword}
        onChange={event => setKeyword(event.target.value)}
        onKeyDown={handleSearch}
        _focus={{
          border: `2px solid ${currentTheme?.primaryColor ?? 'primary.700'}`,
          opacity: 1
        }}
      />
      <InputRightElement width="100px" paddingRight={1}>
        <Button
          height={8}
          border={0}
          background="gray.100"
          gap={{ base: 0, md: 2 }}
          padding="10px 12px"
          onClick={() => gotoSearchPage()}
        >
          <Text
            color="gray.700"
            fontFamily="Inter"
            fontSize={{ base: '0px', md: '14px' }}
            fontWeight={500}
            lineHeight="20px"
          >
            Search
          </Text>
          <SvgIcon iconName="search" size={14} color="gray.700" />
        </Button>
      </InputRightElement>
    </InputGroup>
  )
}

export default observer(TopbarSearch)
